// extracted by mini-css-extract-plugin
export default {"toc":"M_b3","h3toc":"M_b4","linkText":"M_b5","tocTitle":"M_b6"};